// Cart drawer upsell — adds the recommended product via AJAX and refreshes the drawer.
// Uses document-level delegation because cart-drawer re-renders #CartDrawer's innerHTML,
// which would otherwise destroy any directly-bound listeners.
(function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-cart-upsell]');
    if (!button) return;

    event.preventDefault();
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.hasAttribute('aria-busy')) return;

    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer
      ? cartDrawer.getSectionsToRender().map((s) => s.id)
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          // Error (e.g. sold out) — surface it on the button.
          button.classList.add('cart-upsell__add--error');
          return;
        }
        // On the full cart page, reload so the line items + totals refresh.
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else {
          window.location = window.routes ? window.routes.cart_url : '/cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell' });
        }
      })
      .catch(() => {
        button.classList.add('cart-upsell__add--error');
      })
      .finally(() => {
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
      });
  });
})();
